<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link href="/" class="brand-logo">
      <h2 class="brand-text text-primary ml-1">
        Purple Visits
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          Your login has expired.
        </h2>
        <p class="mb-2">
          The magic link you used to sign in has now expired!
        </p>
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
